angular.module('bizmetryApp').filter('timeWithMillis', function () {
  return function (timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const millis = date.getMilliseconds().toString().padStart(3, '0');
    return `${hours}:${minutes}:${seconds}.${millis}`;
  };
});

// < 1 MB -> KB, 1 MB <= x < 1 GB -> MB, >= 1 GB -> GB.
angular.module('bizmetryApp').filter('bmBytes', function () {
  const KB = 1024;
  const MB = 1024 * 1024;
  const GB = 1024 * 1024 * 1024;
  return function (bytes) {
    const n = bytes || 0;
    if (n < MB) return (n / KB).toFixed(2) + ' KB';
    if (n < GB) return (n / MB).toFixed(2) + ' MB';
    return (n / GB).toFixed(2) + ' GB';
  };
});

// < 10,000 -> as-is, 10,000 <= x < 1,000,000 -> thousands with K, >= 1,000,000 -> millions with M.
angular.module('bizmetryApp').filter('bmCompactNumber', function () {
  const K = 1000;
  const M = 1000 * 1000;
  return function (value) {
    const n = value || 0;
    if (n < 10000) return String(n);
    if (n < M) return (n / K).toFixed(2) + 'K';
    return (n / M).toFixed(2) + 'M';
  };
});

// Shared 3-stop RGB interpolation for the green/amber/red gauge colors below
// — explicit named stops (not an HSL hue sweep) so the mid-value color is
// unambiguously "amber", not some in-between hue that reads as muddy at a
// glance. Stops are Material's own "Accent" (A700/A400) shades specifically
// because they're the most saturated/vivid entries in that palette — a
// muted mid-tone here defeats the point of a red/amber/green gauge, it has
// to read as vivid at a glance, not just "colored".
const GAUGE_STOPS_VIVID = [
  { r: 255, g: 23,  b: 68  }, // red    — Material Red A400   #FF1744
  { r: 255, g: 214, b: 0   }, // amber  — Material Yellow A700 #FFD600
  { r: 0,   g: 200, b: 83  }  // green  — Material Green A700 #00C853
];

function interpolate3StopColor(pct, stops) {
  const clamped = Math.max(0, Math.min(100, Number(pct) || 0));
  const segment = clamped < 50 ? 0 : 1;
  const t = clamped < 50 ? clamped / 50 : (clamped - 50) / 50;
  const a = stops[segment];
  const b = stops[segment + 1];
  const r = Math.round(a.r + (b.r - a.r) * t);
  const g = Math.round(a.g + (b.g - a.g) * t);
  const bl = Math.round(a.b + (b.b - a.b) * t);
  return 'rgb(' + r + ', ' + g + ', ' + bl + ')';
}

// Two directions over the same 3 stops — which end is "bad" differs per
// metric (see the two filters below), so each just walks this shared array
// forwards or backwards instead of duplicating the interpolation math.
const GAUGE_STOPS_RED_TO_GREEN = GAUGE_STOPS_VIVID;
const GAUGE_STOPS_GREEN_TO_RED = GAUGE_STOPS_VIVID.slice().reverse();

// Red (0%) -> amber -> green (100%) for a 0-100 gauge where LOW is the bad
// end and HIGH is the good end (e.g. Upload Throughput — 0% means nothing
// uploaded yet, 100% means fully caught up). One shared filter so the
// several places that each render their own gauge bar (biz-interceptors-
// tab.css's inline summary bar, consolidated-stats-dialog.css's tile +
// compact per-env column, environment-status-dialog.css's tile) all shift
// color identically instead of independent, driftable copies of the same
// gradient math.
angular.module('bizmetryApp').filter('ratioColor', function () {
  return function (value) {
    return interpolate3StopColor(value, GAUGE_STOPS_RED_TO_GREEN);
  };
});

// Same 3 stops as ratioColor above, mirrored: for a 0-100 gauge where LOW is
// the GOOD end and HIGH is the bad end (Pressure, Hogging Trend — 0% is
// healthy, 100% is maxed out/breaking even).
angular.module('bizmetryApp').filter('pressureColor', function () {
  return function (value) {
    return interpolate3StopColor(value, GAUGE_STOPS_GREEN_TO_RED);
  };
});

// Search highlighting: every case-insensitive occurrence of `term` in `text` is wrapped in
// <mark class="bm-hl"> (light yellow, see shared-components.css). The text is HTML-escaped
// first, so the result is safe for ng-bind-html. Same rule as the server-side search:
// a plain "contains", no wildcards.
angular.module('bizmetryApp').filter('bmHighlight', ['$sce', function ($sce) {
  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  return function (text, term) {
    var str = text === null || text === undefined ? '' : String(text);
    var needle = (term || '').trim().toLowerCase();
    if (!needle) { return $sce.trustAsHtml(escapeHtml(str)); }
    var lower = str.toLowerCase();
    var out = '';
    var from = 0;
    var at;
    while ((at = lower.indexOf(needle, from)) !== -1) {
      out += escapeHtml(str.slice(from, at))
          + '<mark class="bm-hl">' + escapeHtml(str.slice(at, at + needle.length)) + '</mark>';
      from = at + needle.length;
    }
    return $sce.trustAsHtml(out + escapeHtml(str.slice(from)));
  };
}]);

// True when `value` (objects compared as their JSON text) contains `term`, case-insensitive.
angular.module('bizmetryApp').filter('bmContains', function () {
  return function (value, term) {
    var needle = (term || '').trim().toLowerCase();
    if (!needle || value === null || value === undefined) { return false; }
    var text = typeof value === 'object' ? JSON.stringify(value) : String(value);
    return text.toLowerCase().indexOf(needle) !== -1;
  };
});
